import { useLanguage } from '../../contexts/LanguageContext';
import { localeUpperCase } from '../../lib/textCase';

// KVKK: gerçek/tanımlanabilir öğrenci adı KULLANILMAZ. Tamamen yer tutucu,
// tek harfli rumuz + rol etiketiyle anonimleştirilmiş örnek yorumlar.
// Yayın öncesi izinli gerçek öğrenci hikayeleriyle değiştirilmeli.
const TESTIMONIALS = [
  { key: 't1', initial: 'A', color: '#16794a' },
  { key: 't2', initial: 'B', color: '#C9A227' },
  { key: 't3', initial: 'C', color: '#4d90bd' },
  { key: 't4', initial: 'D', color: '#1f9e4c' },
];

export default function TestimonialsSection() {
  const { t, lang } = useLanguage();

  return (
    <section className="bg-[#0B1A33] py-16 md:py-20 px-6 relative overflow-hidden" data-testid="landing2-testimonials">
      <div
        className="absolute top-8 left-[6%] text-[140px] md:text-[180px] font-black leading-none pointer-events-none select-none"
        style={{ color: 'rgba(201,162,39,.12)' }}
        aria-hidden="true"
      >
        &ldquo;
      </div>
      <div
        className="absolute bottom-0 right-[6%] text-[140px] md:text-[180px] font-black leading-none pointer-events-none select-none"
        style={{ color: 'rgba(201,162,39,.12)' }}
        aria-hidden="true"
      >
        &rdquo;
      </div>
      <div className="max-w-4xl mx-auto relative">
        <h2 className="landing2-display text-2xl md:text-[34px] mb-9 max-w-[12ch] text-[#F7F5F0]">
          {localeUpperCase(t('landing2.testimonials.title'), lang)}
        </h2>
        <div className="columns-1 md:columns-2 gap-8">
          {TESTIMONIALS.map((item) => (
            <div key={item.key} className="break-inside-avoid mb-7" data-testid={`testimonial-${item.key}`}>
              <div className="flex items-center gap-3 mb-3">
                <div
                  className="w-[42px] h-[42px] rounded-full flex items-center justify-center text-white font-extrabold text-[15px] flex-shrink-0"
                  style={{ background: item.color }}
                  aria-hidden="true"
                >
                  {item.initial}
                </div>
                <div>
                  <span className="inline-block bg-[#C9A227]/15 text-[#C9A227] text-[10px] font-extrabold tracking-wide px-2 py-0.5 rounded">
                    {localeUpperCase(t(`landing2.testimonials.${item.key}.role`), lang)}
                  </span>
                </div>
              </div>
              <p className="text-[15px] leading-relaxed text-[#cdd6e3]">
                {t(`landing2.testimonials.${item.key}.quote`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
